import {priority} from '@priority-software/priority-proto-api/lib';
import {IExtendedCondition, ISearchCondition, ISearchFilter} from '../../types/filters';

function buildQuery(filter: ISearchCondition): IExtendedCondition[] {
    const {values, columnID, columnName} = filter;
    const value = values[0];
    if (value === 'Y') {
        return [
            {
                Values: ['Y'],
                Operator: priority.netitems.shared.ComparisonOperator.Eq,
                ColumnID: columnID,
                ColumnName: columnName
            }
        ];
    } else
        return [
            {
                Values: ['Y'],
                Operator: priority.netitems.shared.ComparisonOperator.Ne,
                ColumnID: columnID,
                ColumnName: columnName
            }
        ];
}

function serialize(condiions: IExtendedCondition[]): ISearchFilter {
    const filter = condiions[0];
    const {Values, ColumnID, IgnoreCase, Operator} = filter;

    const value =
        Operator === priority.netitems.shared.ComparisonOperator.Ne && Values[0] === 'Y'
            ? 'N'
            : Values[0];

    return {
        values: [value],
        columnID: ColumnID,
        ignoreCase: IgnoreCase
    };
}

export {buildQuery, serialize};
